export default function Button({ children, variant = "default", size = "md", className = "", onClick, ...props }) {
    const base = "inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-2xl";
    const sizes = { sm: "h-9 px-3 text-sm", md: "h-10 px-4 text-sm", lg: "h-11 px-5 text-base" };
    const variants = {
        default     :   "bg-zinc-900 text-white hover:bg-zinc-800 focus:ring-zinc-400",
        main        :   "bg-white text-black hover:bg-zinc-200 focus:ring-zinc-400",
        secondary   :   "bg-zinc-100 text-zinc-900 hover:bg-zinc-200 focus:ring-zinc-300",
        ghost       :   "bg-transparent text-zinc-700 hover:bg-zinc-100 focus:ring-zinc-300",
        outline     :   "border border-zinc-300 text-zinc-800 hover:bg-zinc-50 focus:ring-zinc-300",
        delete      :   "bg-red text-black hover:bg-red/50 focus:ring-zinc-400",
    };
    return (
        <button className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} onClick={onClick} {...props}>
            {children}
        </button>
    );
}
